import EmailConfirmationForm from "../../components/EmailConfirmForm/EmailConfirmationForm";

const EmailConfirmation = () => {
  return <EmailConfirmationForm />;
};

export default EmailConfirmation;
